"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _useGetDevicesByParams = require("../../../hooks/store/useGetDevicesByParams");
var _DeviceByProductCode = require("./DeviceByProductCode");
var _widgets = require("../../../widgets");
var _TemperaturePanelRotationControl = require("../Panels/TemperaturePanelRotationControl");
var _useGetValue = require("../../../hooks/useGetValue");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @method Device
 *
 * @param {string} equipmentType
 * @param {string} equipmentId
 * @param {string} thingLoopType
 * @param {string} thingSectionType
 * @param {string} pipe
 * @param {[number]} cardPosition
 * @param {[number]} panelPosition
 * @param {string} requiredType sensorTypes['temperatureSensor' || 'smartValve' || 'energyValve' || 'pump']
 * @param {string} requiredTypeNot
 * @param {boolean} anywayShow only with requiredType or requiredTypeNot
 * @param {Object} modelProps
 * @param {Object} panelProps
 * @param {boolean} visible
 * @return {unknown}
 * @constructor
 */
const Device = _ref => {
  let {
    equipmentType = '',
    equipmentId = '',
    thingLoopType,
    thingSectionType,
    pipe = '',
    cardPosition = [3, 10, -3.5],
    panelPosition = [0, -4, 0],
    requiredType = '',
    requiredTypeNot = '',
    anywayShow = false,
    modelProps = {},
    panelProps = {},
    visible = false
  } = _ref;
  const {
    thingPDIDDevice
  } = (0, _useGetDevicesByParams.useGetDeviceByTypeAndPosition)({
    equipmentType,
    equipmentId,
    thingLoopType,
    thingSectionType,
    thingProductDisplayClassification: requiredType,
    thingProductDisplayClassificationNot: requiredTypeNot
  }) || {};
  const temperatureIds = (0, _useGetValue.useGetValueIdsByRegDeviceId)({
    thingPDIDDevice,
    regular: _paulCorePackage.constants.regularsByDisplayNameId.temperatureRegex
  });
  const temperatureIdsList = temperatureIds.length ? temperatureIds : [-1];
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("group", null, /*#__PURE__*/_react.default.createElement(_DeviceByProductCode.DeviceByProductCode, {
    thingPDIDDevice: thingPDIDDevice,
    requiredType: requiredType,
    anywayShow: anywayShow,
    modelProps: modelProps
  }), thingPDIDDevice && visible ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, temperatureIdsList.map((displayNameId, index) => /*#__PURE__*/_react.default.createElement(_TemperaturePanelRotationControl.TemperaturePanelRotationControl, {
    key: displayNameId,
    thingPDIDDevice: thingPDIDDevice,
    displayNameId: displayNameId,
    pipe: pipe,
    panelPosition: panelPosition,
    panelProps: panelProps,
    index: index
  })), /*#__PURE__*/_react.default.createElement(_widgets.TemperatureCard, {
    thingPDIDDevice: thingPDIDDevice,
    position: cardPosition
  })) : null), [thingPDIDDevice, pipe, cardPosition, anywayShow, requiredType, modelProps, panelPosition, temperatureIdsList, panelProps]);
};
var _default = exports.default = Device;